<template>
    <div class="search-content">
        <v-sheet color="primary">
            <v-container>
                <v-row>
                    <v-col cols=12>
                        <v-tabs-items v-model="$store.state.search.searchModel" v-touch="{left: tabNext,right: tabPrev}">
                            <v-tab-item v-for="(tab, n) in $store.state.search.searchTabs" 
                            :id="tab.link" 
                            :value="tab.link" :key="'search-tab-item-'+n" disabled>
                                <v-sheet min-height="100vh">
                                    <router-view v-if="$store.state.search.searchModel === tab.link"></router-view>
                                </v-sheet>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-col>
                </v-row>
            </v-container>
        </v-sheet>
    </div>
</template>
<script>
import { CLEAR_SEARCH_LIST } from "@/store/mutations.type"
export default {
    methods: {
        tabNext() {
            const activeIndex = this.$store.state.search.searchTabs.findIndex(tab => tab.link === this.$store.state.search.searchModel)
            if (activeIndex < this.$store.state.search.searchTabs.length - 1) {
                this.$router.replace(this.$store.state.search.searchTabs[activeIndex + 1].link, () => {})
                this.$router.push(this.$store.state.search.searchTabs[activeIndex + 1].link, () => {})
            }
        },

        tabPrev() {
            const activeIndex = this.$store.state.search.searchTabs.findIndex(tab => tab.link === this.$store.state.search.searchModel)
            if (activeIndex != 0) {
                this.$router.replace(this.$store.state.search.searchTabs[activeIndex - 1].link, () => {})
                this.$router.push(this.$store.state.search.searchTabs[activeIndex - 1].link, () => {})
            }
        }
    },

    destroyed() {
        this.$store.commit(CLEAR_SEARCH_LIST)
    }
}
</script>